import { ENDPOINT_ROUTES, BASE_URL } from "./routes";
import $ from "jquery";

const api = {
  getProtocolById: (protocolId, callback) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/" + protocolId;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  get: (callback, eventId) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/buildingProtocols/";

    if (eventId !== undefined) authEndpointAddress += eventId;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  getProtocolForm: (formType, callback) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/form/" + formType;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  getProtocolFormTemplates: (callback) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/formTemplates";

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  getBuildingsGroups: (callback) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/buildingGroups";

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  save: (formData, callback, queueRequest) => {
    const authEndpointAddress = BASE_URL + ENDPOINT_ROUTES.protocols;

    const form = new FormData();

    // Append regular fields
    for (const key in formData) {
      if (key !== "attachments" && key !== "protocol_files") {
        form.append(
          key,
          typeof formData[key] === "object"
            ? JSON.stringify(formData[key])
            : formData[key]
        );
      }
    }
    // Append files if present
    if (formData.attachments && typeof formData.attachments === "object") {

      Object.entries(formData.attachments).forEach(([id, file]) => {
        if (file instanceof File || file instanceof Blob) {
          form.append(id, file); // key is preserved
        }
      });
    }
    // Append protocol_files (e.g. FileUploader elements) if present
    if (formData.protocol_files && typeof formData.protocol_files === "object") {

      Object.entries(formData.protocol_files).forEach(([id, file]) => {
        if (file instanceof File || file instanceof Blob) {
          form.append(id, file); // key is preserved
        }
      });

      // Also send the list of ids so the server can find the files without parsing "elements"
      form.append("protocol_files", JSON.stringify(Object.keys(formData.protocol_files)));
    }

    $.ajax({
      url: authEndpointAddress,
      type: "POST",
      data: form,
      processData: false,
      contentType: false,
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;
        let offline = false;

        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage =
              "Brak połączenia z Internetem. Dane zostaną zapisane w trybie offline.";
          } else {
            errorMessage =
              "Nie można połączyć się z serwerem. Dane zostaną zapisane w trybie offline.";
          }

          offline = true;

          if (queueRequest) {
            queueRequest(authEndpointAddress, formData, formData.id);
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }

        callback({ success: false, offline, error: errorMessage });
      },
    });
  },

  getSchematics: (callback) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/schematics";

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },

  addSchematic: (file, description, callback) => {
    const authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/schematics";
    const form = new FormData();
    form.append("file", file);
    form.append("description", description);
    $.ajax({
      url: authEndpointAddress,
      type: "POST",
      data: form,
      processData: false,
      contentType: false,
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        // Detect offline or unreachable server
        if (xhr.status === 0) {
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage = "Nie można połączyć się z serwerem.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },

  getProtocolSchematicById: (id, callback) => {
    let authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/schematics/" + id;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      xhrFields: {
        responseType: "blob",
      },
      success: function (blob, status, xhr) {
        callback({ success: true, content: blob });
      },
      error: function (xhr, status, error) {
        callback({ success: false, error: xhr.responseText });
      },
    });
  },

  download: (id, callback) => {
    const authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/download/" + id;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      // Generowanie PDF trwa dłużej niż globalny timeout z $.ajaxSetup (10s)
      timeout: 120000,
      xhrFields: {
        responseType: "blob",
      },
      success: function (blob, status, xhr) {
        callback({ success: true, content: blob });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        if (status === "timeout") {
          errorMessage =
            "Przekroczono czas oczekiwania na wygenerowanie PDF. Spróbuj ponownie.";
        } else if (xhr.status === 0) {
          errorMessage = !navigator.onLine
            ? "Brak połączenia z Internetem."
            : "Nie można połączyć się z serwerem.";
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  display: (formData, callback) => {
    const authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/display";

    $.ajax({
      url: authEndpointAddress,
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(formData),
      // Generowanie PDF trwa dłużej niż globalny timeout z $.ajaxSetup (10s)
      timeout: 120000,
      xhrFields: {
        responseType: "blob",
      },
      success: function (blob, status, xhr) {
        callback({ success: true, content: blob });
      },
      error: function (xhr, status, error) {
        let errorMessage;

        if (status === "timeout") {
          errorMessage =
            "Przekroczono czas oczekiwania na wygenerowanie podglądu. Spróbuj ponownie.";
        } else if (xhr.status === 0) {
          // Detect offline or unreachable server
          if (!navigator.onLine) {
            errorMessage = "Brak połączenia z Internetem.";
          } else {
            errorMessage =
              "Nie można połączyć się z serwerem. Podgląd nie jest dostepny w trybie offline.";
          }
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  create: (eventId, callback) => {
    const authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/createFromEvent";

    $.ajax({
      url: authEndpointAddress,
      type: "POST",
      data: JSON.stringify({ eventId: eventId }),
      contentType: "application/json; charset=utf-8",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        callback({ success: false, error: xhr.responseText });
      },
    });
  },
  migrateProtocol: (protocolId, callback) => {
    const authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/migrate/" + protocolId;

    const jqXhr = $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status) {
        if (status === "abort") return;

        let errorMessage;
        if (xhr.status === 0) {
          errorMessage = navigator.onLine
            ? "Nie można połączyć się z serwerem."
            : "Brak połączenia z Internetem.";
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });

    return jqXhr;
  },
  getVersions: (protocolId, callback) => {
    const authEndpointAddress =
      BASE_URL + ENDPOINT_ROUTES.protocols + "/" + protocolId + "/versions";

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        let errorMessage;

        if (xhr.status === 0) {
          errorMessage = navigator.onLine
            ? "Nie można połączyć się z serwerem."
            : "Brak połączenia z Internetem.";
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  getVersion: (protocolId, revision, callback) => {
    const authEndpointAddress =
      BASE_URL +
      ENDPOINT_ROUTES.protocols +
      "/" +
      protocolId +
      "/versions/" +
      revision;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      contentType: "application/json; charset=utf-8",
      success: function (response) {
        callback({ success: true, content: response });
      },
      error: function (xhr) {
        let errorMessage;

        if (xhr.status === 0) {
          errorMessage = navigator.onLine
            ? "Nie można połączyć się z serwerem."
            : "Brak połączenia z Internetem.";
        } else if (xhr.responseText) {
          errorMessage = xhr.responseText;
        } else {
          errorMessage = "Wystąpił nieznany błąd.";
        }
        callback({ success: false, error: errorMessage });
      },
    });
  },
  remove: (id, callback) => {
    const authEndpointAddress = BASE_URL + ENDPOINT_ROUTES.protocols + "/" + id;

    $.ajax({
      url: authEndpointAddress,
      type: "DELETE",
      success: function (response, status, xhr) {
        callback({ success: true, content: response });
      },
      error: function (xhr, status, error) {
        callback({ success: false, error: xhr.responseText });
      },
    });
  },
  getFile: (protocolId, fileId, callback) => {
    const authEndpointAddress =
      BASE_URL +
      ENDPOINT_ROUTES.protocols +
      "/" +
      protocolId +
      "/files/" +
      fileId;

    $.ajax({
      url: authEndpointAddress,
      type: "GET",
      xhrFields: {
        responseType: "blob",
      },
      success: function (blob, status, xhr) {
        callback({
          success: true,
          content: { file: blob, type: xhr.getResponseHeader("Content-Type") },
        });
      },
      error: function (xhr, status, error) {
        callback({ success: false, error: xhr.responseText });
      },
    });
  },
};

const protocolsApi = { api };

export default protocolsApi;
